import { SR_API_ACTION_HITLIST_TASK_GET_CALL_SCRIPTS } from 'api/actionTypes';

export default async function getCallScripts({ state, apiClient }, { refresh } = {}) {
  const statePath = ['hitlistTask', 'callScripts'];
  if (state.get(statePath) && !refresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_HITLIST_TASK_GET_CALL_SCRIPTS,
    state: state,
    onSuccess(hitlistCallScripts) {
      const callScriptsByType = hitlistCallScripts.reduce(
        (memo, script) => ({
          ...memo,
          [script.hitlistTaskType]: script.callScript.replace(/\\n/g, '\n'),
        }),
        {},
      );

      state.set(statePath, callScriptsByType);
    },
  });
}
